import React from "react";
import { Link } from "react-router-dom";

const NavBar = () => {
  return (
    <nav
      style={{
        display: "flex",
        padding: "10px",
        backgroundColor: "white",
        width: "100%",
        position: "fixed",
        top: "0",
      }}
    >
      <div style={{ marginRight: "auto" }}>
        <Link to="/">
          <img
            src={process.env.PUBLIC_URL + "/logo.png"}
            alt="logo"
            style={{ height: "40px", marginLeft: "10px" }}
          />
        </Link>
      </div>
      <div>
        <Link
          to="/statistiky"
          style={{
            textDecoration: "none",
            color: "#0077b6",
            marginRight: "20px",
            fontSize: "20px",
          }}
        >
          Statistiky
        </Link>
      </div>
    </nav>
  );
};

export default NavBar;
